module.exports = "**我的数据存储在哪里？**\n\n如果您的文档空间没有同步，则文件存储在浏览器中，无处可寻。\n\n我们建议同步您的文档空间，以确保在清除浏览器数据的情况下不会丢失文件。自托管Gitea后端非常适合保证隐私。\n\n**StackEdit中文版可以访问我的数据而不告诉我吗？**\n\nStackEdit中文版是一个基于浏览器的应用程序。Gitee，Github，Dropbox ...发出的访问令牌存储在您的浏览器中，不会发送到任何形式的后端或第三方，因此任何人都不会访问您的数据。\n"


//////////////////
// WEBPACK FOOTER
// ./src/data/faq.md
// module id = 2276
// module chunks = 1